import { createStyles, makeStyles } from '@material-ui/styles';
import SpringBackgroundPattern from '../../assets/background/loginLayout/loginBackgroundSpring.svg';
import AutumnBackgroundPattern from '../../assets/background/loginLayout/loginBackgroundAutumn.svg';
import palette from '../../theme/palette';
import { CURRENT_CHALLENGE_SEASON } from 'helpers/challenge/getChallengeInfos';

const style = () =>
  createStyles({
    root: {
      color: palette.text.white,
      backgroundImage: `url(${
        CURRENT_CHALLENGE_SEASON === 'autumn'
          ? AutumnBackgroundPattern
          : SpringBackgroundPattern
      })`,
      backgroundSize: 'cover',
      position: 'absolute',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
      padding: '60px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      userSelect: 'none'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
